import { useEffect, useRef } from 'react';

import { trackPageView } from '@crehana/analytics';
import { useMe } from '@crehana/auth';

type Params = Parameters<typeof trackPageView>;
type UsePageViewFn = (...args: Params) => void;

export const usePageView: UsePageViewFn = ({ type, id, page, pageData }) => {
  const { me, loading, error } = useMe();
  const tracked = useRef(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  useEffect(() => {
    if (!tracked.current && !loading && !error) {
      trackPageView({ type, id, page, user: me, pageData });
      tracked.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me, loading, error]);
};
